export default __webpack_public_path__ + "static/needlwfilewithoutdust-fb621024e641ff651e218c6f5637e4a4.png";